/**
 * Copyright IBM Corp. 2021
 *
 * This source code is licensed under the IBM Public License Version 1.0 found in the
 * LICENSE file in the root directory of this source tree.
 */
import TriFloorPlanPlugin from "./TriFloorPlanPlugin.js";
import TriFloorPlanUtils from "../util/TriFloorPlanUtils.js";

const svgLastViewBoxMap = new Map();

export default class TriLastPositionPlugin extends TriFloorPlanPlugin {
  static type = "last-position";

  pluginDidUpdate() {
    const { floorPlanLoaded, enabled, svgViewBox } = this.props;
    if (!floorPlanLoaded || !enabled) {
      return;
    }
    if (floorPlanLoaded !== this.lastFloorPlanLoaded) {
      this.loadLastSvgViewBox();
      this.lastFloorPlanLoaded = floorPlanLoaded;
    } else if (
      !TriFloorPlanUtils.isSvgViewBoxEquals(svgViewBox, this.lastSvgViewBox)
    ) {
      this.cacheSvgViewBox(svgViewBox);
      this.lastSvgViewBox = svgViewBox;
    }
  }

  cacheSvgViewBox(svgViewBox) {
    if (svgViewBox != null) {
      svgLastViewBoxMap.set(
        `${this.props.triFloorPlan.floorPlanId}`,
        svgViewBox
      );
    }
  }

  loadLastSvgViewBox() {
    const lastSvgViewBox = svgLastViewBoxMap.get(
      `${this.props.triFloorPlan.floorPlanId}`
    );
    if (lastSvgViewBox != null) {
      this.props.triFloorPlan.svgViewBox = lastSvgViewBox;
    }
  }
}
